export default __webpack_public_path__ + "static/media/gambar-23.ee072f05.png";